import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-midnight-900 pt-20 pb-16 px-4" data-id="element-18">
      {/* Background gradient effect - Lamp glow */}
      <div className="absolute inset-0 overflow-hidden z-0 pointer-events-none" data-id="element-19">
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,rgba(45,125,255,0.08)_0%,transparent_60%)]" data-id="element-20" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto w-full" data-id="element-21">
        {/* Time Display */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1
      }} className="flex justify-center mb-8 relative" data-id="element-22">
          {/* Red Pulse Circle */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 border border-accent-red rounded-full animate-pulse-once pointer-events-none" data-id="element-23" />

          <div className="font-mono text-5xl md:text-7xl font-bold text-accent-red tracking-widest text-glow-red" data-id="element-24">
            3:12 <span className="text-2xl md:text-4xl" data-id="element-25">AM</span>
          </div>
        </motion.div>

        {/* Narrative */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.3
      }} className="space-y-6 text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto text-center mb-12 font-light" data-id="element-26">
          <p data-id="element-27">No es que estés "despierta".</p>
          <p className="font-medium text-white" data-id="element-28">
            Es que estás{' '}
            <span className="text-accent-red font-bold" data-id="element-29">en alerta</span>.
          </p>
          <p className="text-slate-300" data-id="element-30">
            El pecho raro. La mente encendida. El cuerpo caliente.
          </p>
          <p className="italic text-slate-400/80" data-id="element-31">
            "Ya se arruinó la noche… y mañana también."
          </p>
        </motion.div>

        {/* Main Image - YouTube Thumbnail Aesthetic */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.3
      }} className="relative mb-12 rounded-[18px] overflow-hidden shadow-2xl border border-[rgba(255,255,255,0.08)]" data-id="element-32">
          <img src="https://cdn.magicpatterns.com/uploads/qhpbT1rgUrnr1ytLaLDyUj/menospausi.png" alt="Mujer despierta a las 3AM con ansiedad" className="w-full h-auto object-cover max-h-[500px] brightness-90 contrast-110" data-id="element-33" />
          <div className="absolute inset-0 bg-gradient-to-t from-midnight-900 via-transparent to-transparent opacity-80" data-id="element-34" />
        </motion.div>

        {/* Headline & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.3
      }} className="text-center space-y-8" data-id="element-35">
          <div className="space-y-6" data-id="element-36">
            <h1 className="text-4xl md:text-6xl font-display font-bold text-white leading-tight uppercase tracking-wide" data-id="element-37">
              Si te despiertas a las 3AM, no necesitas fuerza.{' '}
              <br className="hidden md:block" data-id="element-38" />
              <span className="text-accent-blue" data-id="element-39">Necesitas un protocolo.</span>
            </h1>

            {/* Badges */}
            <div className="flex flex-wrap justify-center gap-3" data-id="element-40">
              <span className="border border-accent-blue text-white text-xs px-3 py-1 rounded-full tracking-wider uppercase" data-id="element-41">
                Rescate 12 min
              </span>
              <span className="border border-accent-red text-white text-xs px-3 py-1 rounded-full tracking-wider uppercase" data-id="element-42">
                Sin pantalla
              </span>
            </div>
          </div>

          <p className="text-slate-300 max-w-2xl mx-auto" data-id="element-43">
            No es tu falta de disciplina. Es que nadie te dio un plan para el
            momento exacto en el que tu cuerpo dispara la alarma.
          </p>

          <div className="pt-4" data-id="element-44">
            <Button href="https://cuerpoencalma.it.com/cart/47459892756667:1" data-id="element-45">
              Quiero dormir sin ansiedad
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}